import { render } from "./form-register.vue?vue&type=template&id=33f0ecb3&scoped=true"
import script from "./form-register.vue?vue&type=script&lang=js"
export * from "./form-register.vue?vue&type=script&lang=js"

import "./form-register.vue?vue&type=style&index=0&id=33f0ecb3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f0ecb3"]])

export default __exports__